import _ from 'lodash'
import { creationTypeList } from '@/views/demand/utils/creation'
import useValueExchangeLabel from '@/utils/useValueExchangeLabel'
import { platformList as platforms } from '@com/utils/platform.js'

export const mediaTypeOptions = [
  {
    value: 'media',
    label: '大媒体',
  },
  {
    value: 'mintegral',
    label: 'Mintegral',
  },
  {
    value: 'design',
    label: '设计项目',
  },
]

export const statusOptions = [
  {
    value: 'unsubmit', // 1
    label: '待提交',
  },
  {
    value: 'submited', // 2
    label: '已提交',
  },
  {
    value: 'rejected', // 3
    label: '已驳回',
  },
  {
    value: 'confirmed', // 4
    label: '已确认',
  },
  {
    value: 'planned',
    label: '待配置美术资源',
  },
  // {
  //   value: 'dev_unassigned',
  //   label: '待分配研发',
  // },
  {
    value: 'dev_rejected',
    label: '研发驳回',
  },
  {
    value: 'dev_confirmed',
    label: '待研发',
  },
  {
    value: 'dev_ongoing',
    label: '研发中',
  },
  // 产品删除要求删除已排期状态，ID 等于 5
  // http://confluence.mobvista.com/pages/viewpage.action?pageId=16709543
  {
    value: 'delivered', // 6
    label: '已交付',
  },
  {
    value: 'discarded',
    label: '已作废',
  },
  {
    value: 'test_failed',
    label: '测试不通过',
  },
]

export const platformList = [
  ..._.cloneDeep(platforms),
  {
    value: 'website',
    label: 'Website',
  },
]

export const timeFilterOptions = [
  {
    value: 'submit_time',
    label: '按提需日期',
  },
  {
    value: 'expect_time',
    label: '按期望交付日期',
  },
  {
    value: 'deliver_time',
    label: '按实际完成日期',
  },
  {
    value: 'estimated_time',
    label: '按计划完成日期',
  },
]

// 是否大客户
export const customerTypeList = [
  {
    value: 1,
    label: 'SKA',
  },
  {
    value: 2,
    label: 'KA',
  },
  {
    value: 3,
    label: '非KA',
  },
]

// 广告主分级
export const advGradeList = [
  {
    label: 'SKA',
    value: 1,
  },
  {
    label: 'KA',
    value: 2,
  },
  {
    label: 'A',
    value: 3,
  },
  {
    label: 'B',
    value: 4,
  },
  {
    label: 'C',
    value: 5,
  },
  {
    label: 'undetermined',
    value: -1,
  },
]

export const paymentList = [
  {
    value: 2,
    label: '免费',
  },
  {
    value: 1,
    label: '付费',
  },
]

export const currencyList = [
  {
    value: 1,
    label: '美元',
  },
  {
    value: 2,
    label: '人民币',
  },
]

export const ratingList = [
  {
    value: 'S',
    label: 'S',
  },
  {
    value: 'A',
    label: 'A',
  },
  {
    value: 'B',
    label: 'B',
  },
  {
    value: 'C',
    label: 'C',
  },
  {
    value: 'D',
    label: 'D',
  },
]

export const keyworkList = [
  {
    value: 'creative_id',
    label: '创意方向id',
  },
  {
    value: 'creative_name',
    label: '创意方向名称',
  },
  {
    value: 'creative_spec',
    label: '创意说明',
  },
  {
    value: 'id',
    label: '需求ID',
  },
  {
    value: 'name',
    label: '需求名称',
  },
  {
    value: 'app_name',
    label: '产品名称',
  },
  {
    value: 'package_name',
    label: 'App包名',
  },
]

// mtg 每日消耗
export const dailyCostList = [
  {
    value: 1,
    label: '0-500',
  },
  {
    value: 2,
    label: '500-1000',
  },
  {
    value: 3,
    label: '1000-2000',
  },
  {
    value: 4,
    label: '2000-3000',
  },
  {
    value: 5,
    label: '3000-5000',
  },
  {
    value: 6,
    label: '5000-10000',
  },
  {
    value: 7,
    label: '10000+',
  },
]

// 需求归属
export const categoryList = [
  {
    value: 'media',
    label: '大媒体',
  },
  {
    value: 'mintegral',
    label: 'Mintegral',
  },
  {
    value: 'design',
    label: '设计项目',
  },
]

// 投放渠道类型
export const channelTypeList = [
  {
    value: 1,
    label: 'Mintegral',
  },
  {
    value: 2,
    label: '大媒体',
  },
]

// 素材类型
export const typeList = [
  {
    value: 1,
    label: '交互素材',
  },
  {
    value: 2,
    label: '非交互素材',
  },
]

// 素材来源
export const sourceList = [
  {
    value: 1,
    label: '客户提供（非ss）',
  },
  {
    value: 2,
    label: '内部制作',
  },
  {
    value: 3,
    label: '客户提供（ss）',
  },
]

// 素材子来源
export const subSourceList = [
  {
    value: 1,
    label: '研发自制',
    parent: 2,
  },
  {
    value: 2,
    label: 'PT 关联需求提测',
    parent: 2,
  },
  {
    value: 3,
    label: 'PS 关联需求提测',
    parent: 2,
  },
  {
    value: 4,
    label: 'PT 推送&下载产生',
    parent: 4,
  },
  {
    value: 5,
    label: 'PS 推送&下载产生',
    parent: 4,
  },
  {
    value: 6,
    label: '模版转换产生',
    parent: 4,
  },
]

export const advertiserAuditList = [
  {
    value: 1,
    label: '是的，需要审核',
  },
  {
    value: 2,
    label: '否，不审核',
  },
]

// 大媒体业务类型
export const businessTypeList = [
  {
    value: 1,
    label: '常规',
  },
  {
    value: 2,
    label: '试新',
  },
]

// 项目类型
export const projectTypeList = [
  {
    value: 1,
    label: '轻度游戏',
  },
  {
    value: 2,
    label: '中重度游戏',
  },
  {
    value: 3,
    label: '网赚产品',
  },
  {
    value: 4,
    label: '工具产品',
  },
  {
    value: 5,
    label: '电商网服产品',
  },
  {
    value: 6,
    label: '五垂产品',
  },
  {
    value: 7,
    label: '真金产品',
  },
  {
    value: 8,
    label: '重定向产品',
  },
  {
    value: 9,
    label: '社交',
  },
  {
    value: 10,
    label: '赌博',
  },
  {
    value: 99,
    label: '其他',
  },
]

// 服务归属
export const serviceAttribution = [
  {
    label: '定制',
    prop: 'custom',
    value: 1,
  },
  {
    label: '媒体',
    prop: 'media',
    value: 2,
  },
  {
    label: '模板',
    prop: 'template',
    value: 3,
  },
]

// 服务类型
export const serviceList = [
  {
    label: '2D定制',
    value: 1,
  },
  {
    label: '3D定制',
    value: 2,
  },
  {
    label: 'MPL定制',
    value: 3,
  },
  {
    label: 'IV定制',
    value: 4,
  },
  {
    label: '换皮/迭代',
    value: 5,
  },
  {
    label: '渠道适配',
    value: 6,
  },
  {
    label: 'IEC定制',
    value: 7,
  },
  {
    label: '媒体初级',
    value: 8,
  },
  {
    label: '媒体中级',
    value: 9,
  },
  {
    label: '媒体高级',
    value: 10,
  },
  {
    label: '模板化',
    value: 11,
  },
  {
    label: 'PT模板',
    value: 12,
  },
]
export const serviceType = {
  custom: serviceList.slice(0, 7), // 0 - 6
  media: serviceList.slice(7, 10), // 7 - 9
  template: serviceList.slice(10), // 10 - 12
}

export const bigMediaCreativeTypeList = [
  {
    value: '对比',
    label: '对比',
  },
  {
    value: '解说',
    label: '解说',
  },
  {
    value: '其他',
    label: '其他',
  },
]

export const interactiveMaterialTypeList = [
  {
    value: 1,
    label: 'playable2d',
  },
  {
    value: 2,
    label: 'playable3d',
  },
  {
    value: 3,
    label: 'miniplayable',
  },
  {
    value: 4,
    label: 'interactive endcard',
  },
  {
    value: 5,
    label: 'interactive video',
  },
]

// 非交互素材二级标签
export const noninteractiveSecondaryLevelTagList = [
  {
    value: 1,
    label: 'UA视频',
  },
  {
    value: 2,
    label: '品宣视频',
  },
  {
    value: 3,
    label: '商店视频',
  },
  {
    value: 4,
    label: 'KOL',
  },
  {
    value: 5,
    label: '直播',
  },
  {
    value: 99,
    label: '其他',
  },
]

export const noninteractiveThirdLevelTagList = [
  {
    value: 1,
    label: '3D动画',
  },
  {
    value: 2,
    label: '2D动画',
  },
  {
    value: 3,
    label: '真人实拍',
  },
  {
    value: 4,
    label: 'MG动画',
  },
  {
    value: 5,
    label: '平面设计',
  },
  {
    value: 99,
    label: '其他',
  },
]

export const caseAuthTypeList = [
  {
    value: 1,
    label: '全部授权',
  },
  {
    value: 2,
    label: '不授权',
  },
  {
    value: 3,
    label: '部分授权',
  },
]

export const contentRatingList = [
  {
    value: '-1',
    label: '无',
  },
  {
    value: '8+',
    label: '8+',
  },
  {
    value: '12+',
    label: '12+',
  },
  {
    value: '16+',
    label: '16+',
  },
]

export const reportPointList = [
  {
    value: true,
    label: '需要',
  },
  {
    value: false,
    label: '不需要',
  },
]

export const creativeGenreList = [
  {
    label: 'Hyper Casual',
    value: 'Hyper Casual',
  },
  {
    label: 'Puzzle',
    value: 'Puzzle',
  },
  {
    label: 'Simulation',
    value: 'Simulation',
  },
  {
    label: 'Arcade',
    value: 'Arcade',
  },
  {
    label: 'Strategy',
    value: 'Strategy',
  },
  {
    label: 'Casino',
    value: 'Casino',
  },
  {
    label: 'Shooter',
    value: 'Shooter',
  },
  {
    label: 'RPG',
    value: 'RPG',
  },
  {
    label: 'Lifestyle',
    value: 'Lifestyle',
  },
]

export const exchangeCreationTypes = (creationTypes) => {
  if (creationTypes) {
    const temp = creationTypes.split(',')
    const list = temp.map((item) => {
      return useValueExchangeLabel(Number(item), creationTypeList)
    })
    return list.length ? list.join() : ''
  }
  return ''
}

export const bizScenario = [
  {
    label: '付费制作',
    value: 1,
  },
  {
    label: '创意优化',
    value: 2,
  },
  {
    label: '模板制作',
    value: 3,
  },
  {
    label: '非仓库制作',
    value: 4,
  },
  {
    label: '创意优化-消耗类',
    value: 5,
  },
]

export const gradeList = [
  {
    label: '轻度2D 1档',
    value: 'mild_2d_level1',
  },
  {
    label: '轻度2D 2档',
    value: 'mild_2d_level2',
  },
  {
    label: '轻度2D 3档',
    value: 'mild_2d_level3',
  },
  {
    label: '轻度3D 1档',
    value: 'mild_3d_level1',
  },
  {
    label: '轻度3D 2档',
    value: 'mild_3d_level2',
  },
  {
    label: '轻度3D 3档',
    value: 'mild_3d_level3',
  },
  {
    label: '中重度2D 1档',
    value: 'severe_2d_level1',
  },
  {
    label: '中重度2D 2档',
    value: 'severe_2d_level2',
  },
  {
    label: '中重度2D 3档',
    value: 'severe_2d_level3',
  },
  {
    label: '中重度3D 1档',
    value: 'severe_3d_level1',
  },
  {
    label: '中重度3D 2档',
    value: 'severe_3d_level2',
  },
  {
    label: '中重度3D 3档',
    value: 'severe_3d_level3',
  },
]

export const productionTypeList = [
  {
    label: 'Template',
    value: 'template',
  },
  {
    label: 'Blank Canvas',
    value: 'blank_canvas',
  },
  {
    label: 'Coding',
    value: 'coding',
  },
]

export const serviceTypeList = [
  {
    label: 'Spend Share',
    value: 'spend_share',
  },
  {
    label: 'Playturbo Subscribe',
    value: 'playturbo_subscribe',
  },
  {
    label: 'Customized Playable',
    value: 'customized_playable',
  },
  {
    label: 'mtg Free Endcard',
    value: 'mtg_free_endcard',
  },
  {
    label: 'Other',
    value: 'other',
  },
]

export const producerList = [
  {
    label: 'client',
    value: 'client',
  },
  {
    label: 'mws',
    value: 'mws',
  },
]
